import update from 'immutability-helper';
import moment from 'moment-timezone';

import * as types from './types';

export const SIZE_CAP = 500;

export interface IState {
  filter: any;
  timelineInterval: string;
  timelineSizeCap: number;
  summaries: string[];
  timelines: string[];
}

const initState: IState = {
  filter: [],
  timelineInterval: `${moment()}/${moment()}`,
  timelineSizeCap: 0,
  summaries: [],
  timelines: [],
};

const switchMap: {
  [key in keyof typeof types]?: (
    state: IState,
    action: Partial<{ type: keyof typeof types }>,
  ) => IState;
} = {};

switchMap[types.INIT] = state => update(state, { $set: initState });
switchMap[types.APPLY_REQUEST] = (state, action) =>
  update(state, { $merge: action.request });

switchMap[types.CHANGE_SIZE_CAP] = (state, action) =>
  update(state, { timelineSizeCap: { $set: action.newSizeCap } });

export default (state = initState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
